// Type utilities
export type ActionCreator<TType extends TypeConstant = TypeConstant, TPayload = any, TMeta = never> = {
  (...args: any[]): PayloadAction<TType, TPayload> | PayloadMetaAction<TType, TPayload, TMeta>;
  type: TType;
};

export type RootActionType<T> = T extends ActionCreator<any, any, any>
  ? ActionType<T>
  : T extends { [K in keyof T]: infer U }
  ? RootActionType<U>
  : never;

export type ActionType<T> = T extends ActionCreator<any, any, any>
  ? T extends (...args: any[]) => infer R
    ? R
    : never
  : never;
export type TypeConstant = string;
export type PayloadAction<TType extends TypeConstant, TPayload> = {
  type: TType;
  payload: TPayload;
};
export type PayloadMetaAction<TType extends TypeConstant, TPayload, TMeta> = {
  type: TType;
  payload: TPayload;
  meta: TMeta;
};
// Simple action creator utility
export const createAction = <TType extends string>(type: TType) => {
  function actionCreator<TPayload = void, TMeta = never>(payload?: TPayload, meta?: TMeta) {
    if (meta !== undefined) {
      return { type, payload, meta } as PayloadMetaAction<TType, TPayload, TMeta>;
    }
    return { type, payload } as PayloadAction<TType, TPayload>;
  }
  actionCreator.type = type;
  return actionCreator;
};

export const getType = <T extends { type: string }>(actionCreator: T): T['type'] => actionCreator.type;
